import { useEffect } from 'react'

export const ScrollToFieldError = ({
  scrollBehavior = { behavior: 'smooth', block: 'center' },
  formDetails,
}) => {
  const { submitCount, isValid } = formDetails

  useEffect(() => {
    if (isValid) return

    const fieldNames = Object.keys(formDetails?.errors)

    if (!fieldNames?.length) return

    const element = document.getElementById(fieldNames?.[0])
    if (!element) return

    element.scrollIntoView(scrollBehavior)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitCount])

  return null
}
